import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import ProduttivoMuiTheme from '../components/shared/themes/ProduttivoTheme';
import InvoicesContainer from './invoices/list/InvoicesContainer';
import InvoiceNewContainer from './invoices/new/InvoiceNewContainer';
import InvoiceShowContainer from './invoices/show/InvoiceShowContainer';
import InvoicesSubscriptionContainer from './invoices/subscription/InvoiceSubscriptionContainer';

const mounts = [
  {
    id: 'invoices-container',
    Component: InvoicesContainer,
    getProps: () => ({ accountId: window.currentAccountId }),
  },
  {
    id: 'invoices_create-container',
    Component: InvoiceNewContainer,
  },
  {
    id: 'invoices_show-container',
    Component: InvoiceShowContainer,
    getProps: (el) => ({ invoiceId: el.dataset.invoiceId }),
  },
  {
    id: 'invoices-subscription',
    Component: InvoicesSubscriptionContainer,
  },
];

mounts.forEach(({ id, Component, getProps }) => {
  const el = document.getElementById(id);
  if (!el) return;

  createRoot(el).render(
    <ThemeProvider theme={ProduttivoMuiTheme}>
      <Component {...(getProps?.(el) ?? {})} />
    </ThemeProvider>
  );
});

